import { STORAGE_KEYS } from '@ukpostbox/frontend-framework/lib/FrameworkStorageKeys';
import { AuthorisedUserStoreStateType } from '../../Types/AuthorisedUserStoreTypes';

const localPreferences = localStorage.getItem(STORAGE_KEYS.FRAMEWORK_PREFERENCES);

export const defaultAuthorisedUserStoreData: AuthorisedUserStoreStateType = {
	currentUser: null,
	canByPassLocks: false,
	activeLockByPasses: {},
	userPreferences: localPreferences ? JSON.parse(localPreferences) : null,
};
